import { Link } from "react-router-dom";
import image from "../../assets/images/bg/bg-lines-one.png";
import error from "../../assets/images/svg/error.svg";
import { FiHome } from "../../assets/icons/vander";

export const Error404 = () => {
  return (
    <>
      <div className="back-to-home rounded d-none d-sm-block">
        <Link to="/home" className="btn btn-icon btn-primary">
          <FiHome className="icons" />
        </Link>
      </div>

      <section
        className="bg-home d-flex bg-light align-items-center"
        style={{
          backgroundImage: `url(${image})`,
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7 col-md-10 text-center">
              <img src={error} className="img-fluid" alt="" />
              <h3 className="mb-4">Pagina no encontrada</h3>
              <Link to="/home" className="btn btn-primary mt-2">
                Ir al inicio
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
